













import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({})
export default class Name extends Vue {
  @Prop()
  private data: any;
  @Watch("data", { immediate: true })
  private dataChange() {
    if (this.data) {
      //注意时间会有误差所以是每1050毫秒掉一次
      this.timeInterval = setInterval(() => {
        this.countTime(this.data);
      }, 1050);
    }
  }
  private timeInterval: any = null;
  private h1: any = " ";
  private h2: any = " ";
  private m1: any = " ";
  private m2: any = " ";
  private s1: any = " ";
  private s2: any = " ";
  private countTime(endTime: any) {
    //获取当前时间
    let nowDate = new Date();
    let now = nowDate.getTime();
    //设置截止时间
    let endDate = new Date(endTime);
    let end = endDate.getTime();
    //时间差
    let time: any = null;
    if (end > now) {
      time = end - now;
    } else {
      time = now - end;
    }
    if (time < 1000) {
      this.$emit("update");
    }
    //定义变量,h,m,s保存倒计时的时间
    let h, m, s;
    h = Math.floor(time / 1000 / 60 / 60);
    m = Math.floor((time / 1000 / 60) % 60);
    s = Math.floor((time / 1000) % 60);
    if (h < 10) {
      this.h1 = "0";
      this.h2 = h;
    } else {
      this.h1 = Math.floor(h / 10);
      this.h2 = h % 10;
    }
    if (m < 10) {
      this.m1 = "0";
      this.m2 = m;
    } else {
      this.m1 = Math.floor(m / 10);
      this.m2 = m % 10;
    }
    if (s < 10) {
      this.s1 = "0";
      this.s2 = s;
    } else {
      this.s1 = Math.floor(s / 10);
      this.s2 = s % 10;
    }
  }
  private mounted() {}
  private destroyed() {
    // 离开清除定时器
    clearInterval(this.timeInterval);
  }
}
